import React from "react";

interface HamburgerIconProps {
  isOpen: boolean;
  className?: string;
}

export const HamburgerIcon: React.FC<HamburgerIconProps> = React.memo(({ isOpen, className = "" }) => {
  return (
    <div data-testid="wrapper" className={`flex flex-col justify-center items-center w-8 h-8 space-y-1.5 ${className}`}>
      <span
        data-testid="bar"
        className={`block w-6 h-0.5 bg-blue-600 transition-all duration-300 ${isOpen ? "rotate-45 translate-y-2" : ""}`}
      />
      <span
        data-testid="bar"
        className={`block w-6 h-0.5 bg-blue-600 transition-all duration-300 ${isOpen ? "opacity-0" : ""}`}
      />
      <span
        data-testid="bar"
        className={`block w-6 h-0.5 bg-blue-600 transition-all duration-300 ${
          isOpen ? "-rotate-45 -translate-y-2" : ""
        }`}
      />
    </div>
  );
});

export default HamburgerIcon;
